/* eslint-disable react/no-unknown-property,no-undef */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SidebarGrid, HamBurgerContainer, MainSideBarLinks, Navigation, StyledLink, SidebarCard } from './style';
import Loading from '../Loading';
import { withTranslation } from 'react-i18next';
import isUndefined from 'lodash/isUndefined';
import isNull from 'lodash/isNull';
import Waiting from '../Waiting';
import {  AdminBillingIcon, AdminDashboardIcon, AdminIntegrationsIcon, AdminPeopleIcon, AdminRecognitionIcon, AdminSurveysIcon, HealthDataIcon, UserChallengeIcon, UserCommunityIcon, UserDashboardIcon, UserEventsIcon, UserLeaderBoardIcon, UserRewardsIcon, UserSettingsIcon, UserSocialFeedIcon, UserWellnessIcon } from '../../utils/icons';
import { applyOpacityToColor, fetchApi, hexToRGBA } from '../../utils/methods';
import { GetCompanyBrandingDetails } from '../../redux/constants/apiConstants';
import { setBrandingDetailsGlobally } from '../../redux/actions/wellnessDashboardActions';

const companyNavigationArray = [
  {
    "name": "Admin Panel",
    "id": "admin-panel-nav",
    "active": "admin",
    "route": "/company/admin",
    "width": "18px",
    "height": "20px",
    "value": "adminPanel",
    svg:UserDashboardIcon,
    show:true
  },
  {
    "name": "Dashboard",
    "id": "company-dashboard-nav",
    "active": "dashboard",
    "route": "/company/dashboard",
    "width": "18px",
    "height": "20px",
    "value": "dashboard",
    svg:AdminDashboardIcon,
    show:true
  },
  {
    "name": "People",
    "id": "company-people-nav",
    "active": "people",
    "route": "/company/people",
    "width": "26px",
    "height": "18px",
    "value": "people",
    svg:AdminPeopleIcon,
    show:true
  },
  {
    "name": "Challenges",
    "id": "company-challenges-nav",
    "active": "challenges",
    "route": "/company/challenges",
    "width": "26px",
    "height": "18px",
    "value": "challenges",
    svg:UserChallengeIcon,
    show:true
  },
  {
    "name": "Health Hub",
    "id": "company-people-nav",
    "active": "health",
    "route": "/company/health",
    "width": "20px",
    "height": "21px",
    "padding": "0px 0px 0px 5px",
    "condition": true,
    "value": "health",
    svg:HealthDataIcon,
    show:true
  },
  {
    "name": "Recognition",
    "id": "company-recognition-nav",
    "active": "recognition",
    "route": "/company/recognition",
    "width": "20px",
    "height": "21px",
    "value": "recognition",
    svg:AdminRecognitionIcon,
    show:true
  },
  {
    "name": "Events",
    "id": "company-events-nav",
    "active": "events",
    "route": "/company/events",
    "width": "23px",
    "height": "21px",
    "value": "events",
    svg:UserEventsIcon,
    show:true
  },
  {
    "name": "Rewards",
    "id": "company-rewards-nav",
    "active": "rewards",
    "route": "/company/rewards-management",
    "width": "23px",
    "height": "21px",
    "value": "rewards-points-management",
    svg:UserRewardsIcon,
    show:true
  },
  {
    "name": "Surveys",
    "id": "company-surveys-nav",
    "active": "survey",
    "route": "/company/surveys",
    "width": "23px",
    "height": "21px",
    "padding": "0px 0px 0px 5px",
    "value": "survey",
    svg:AdminSurveysIcon,
    show:true
  },
  {
    "name": "Wellness",
    "id": "company-wellness-nav",
    "active": "wellness",
    "route": "/company/wellness",
    "width": "23px",
    "height": "21px",
    "value": "wellness",
    svg:UserWellnessIcon,
    show:true
  },
  {
    "name": "Integrations",
    "id": "company-hris-nav",
    "active": "/hris",
    "route": "/company/hris-integration",
    "width": "30px",
    "height": "30px",
    "value": "hris",
    svg:AdminIntegrationsIcon,
    show:true
  },
  {
    "name": "Billing",
    "id": "company-billing-nav",
    "active": "billing",
    "route": "/company/billing",
    "width": "23px",
    "height": "21px",
    "padding": "2px 0px 0px 3px",
    "value": "billing",
    svg:AdminBillingIcon,
    show:true
  }
];

class SideBarV5 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company: 'Training Amigo',
      totalPoints: 80,
      showSideBarMenu: false,
      imgSrc: '',
      hide: false,
      hoverState: null,
      hoverStateAdmin: null,
      brandingColor:null,
      companyNavigationArrayState:[],
      companyBrandingDetails:null
    };
  }


  fetchCompanyBrandingDetails = async (companyId) => {
    const { role, hideTab,setBrandingDetailsGlobally } = this.props;
    try {
      const res = await fetchApi("/" + GetCompanyBrandingDetails + "/" +  companyId, "GET");
      if (res?.status === 'success') {
        // this.setState({surveyCategories: res?.categories})
        let navIndex = res?.data?.color_branding?.length > 0 ? res?.data?.color_branding.findIndex((data) => data.custom_name === 'side_menu_color') : -1;
        let brandingColor = navIndex !== -1 ? res?.data?.color_branding[navIndex]?.color_code : "rgba(243, 122, 101, 1)";
        setBrandingDetailsGlobally(res.data,brandingColor)
        this.setState({companyBrandingDetails: res?.data?.company_branding,brandingColor:brandingColor},()=>{
          this.updateCompanyNavigationVisibility(res?.data?.company_branding,role,hideTab)
        })
      } else {
        // toast.error(res?.error);
      }
    } catch (error) {
      window.console.error(error);
    }
  }

  updateCompanyNavigationVisibility = (brandingDetails, role) => {
    const { billingTabStatus } = this.props;
  
    // Always clone base array before mapping
    const updatedNavigation = [...companyNavigationArray].map((nav) => {
      const item = { ...nav }; // shallow clone each
  
      switch (item.value) {
      case "people":
        item.show = !!brandingDetails?.show_employee_directory;
        break;
      case "challenges":
        item.show = !!brandingDetails?.show_challenge;
        break;
      case "health":
        item.show = !!brandingDetails?.show_biometric;
        break;
      case "events":
        item.show = !!brandingDetails?.show_events;
        break;
      case "wellness":
        item.show = !!brandingDetails?.show_education;
        break;
      case "rewards-points-management":
        item.show = !!brandingDetails?.company_rewards;
        break;
      case "survey":
        item.show = !!brandingDetails?.show_survey;
        break;
      case "recognition":
        item.show = !!brandingDetails?.show_recognition;
        break;
      case "billing":
        item.show = !!billingTabStatus;
        break;
      default:
        item.show = true;
      }
  
      // Restrict for non-admins
      if (role !== "ADMIN" && ["adminPanel"].includes(item.value)) {
        item.show = false;
      }
  
      return item;
    });
  
    this.setState({ companyNavigationArrayState: updatedNavigation });
  };


  componentDidMount(){
    const { userCompany } = this.props;
    const companyId = userCompany?.id || 1;
    this.fetchCompanyBrandingDetails(companyId);
  }

  // componentDidUpdate(prevProps){
  //   const{billingTabStatus,role}= this.props;
  //   if (prevProps.billingTabStatus !== billingTabStatus){
  //     this.updateCompanyNavigationVisibility(this.state?.companyBrandingDetails, role)
  //   }
  // }


  componentDidUpdate(prevProps) {
    const { billingTabStatus, role, userCompany } = this.props;
  
    // Watch for the Billing Tab status change
    if (prevProps.billingTabStatus !== billingTabStatus) {
      this.updateCompanyNavigationVisibility(this.state?.companyBrandingDetails, role);
    }
  
    // FIX: Watch for the moment the real Company ID arrives
    if (userCompany?.id && prevProps.userCompany?.id !== userCompany.id) {
      this.fetchCompanyBrandingDetails(userCompany.id);
    }
  }

  
  showSideBarMenuOptions = () => {
    this.setState((prev) => ({
      showSideBarMenu: !prev.showSideBarMenu
    }))
  };


  changeRoute = (value) => {
    const { history } = this.props;
    this.setState({
      showSideBarMenu: false
    });
    history.push(value);
  };



  showCard = (value) => {
    this.setState({
      hoverState: value
    });
  }

  showCardAdmin = (value) => {
    this.setState({
      hoverStateAdmin: value
    });
  }

  hideCard = () => {
    this.setState({
      hoverState: null
    });
  }

  hideCardAdmin = () => {
    this.setState({
      hoverStateAdmin: null
    });
  }

  getCommonNavigationConfig = () => {
    const { role,/*userCompany*/ } = this.props;
    const { companyBrandingDetails } = this.state;
  
    return [
      {
        id: "wellness-dashboard-nav",
        label: "Dashboard",
        route: "/portal",
        icon: UserDashboardIcon,
        showKey: "user_dashboard",
      },
      {
        id: "challenges-nav",
        label: "Challenges",
        route: "/challenges",
        icon: UserChallengeIcon,
        showKey: "show_challenge",
      },
      {
        id: "newsFeed-nav",
        label: "Social Feed",
        route: "/social",
        icon: UserSocialFeedIcon,
        showKey: "social_feed",
      },
      {
        id: "adventures-nav",
        label: "Wellness",
        // route: userCompany?.id === 1 || userCompany?.id === 18 ? "/wellness-resources" : "/education/adventure",
        route:"/wellness-resources",
        icon: UserWellnessIcon,
        showKey: "show_education",
      },
      {
        id: "employeeDirectory-nav",
        label: "Community",
        route: "/community",
        icon: UserCommunityIcon,
        showKey: "show_employee_directory",
      },
      {
        id: "leaderboard-nav",
        label: "Leaderboard",
        route: "/leaderboard",
        icon: UserLeaderBoardIcon,
        showKey: "leaderboard",
      },
      {
        id: "events-nav",
        label: "Events",
        route: "/events",
        icon: UserEventsIcon,
        showKey: "show_events",
      },
      {
        id: "rewards-nav",
        label: "Rewards",
        route: "/rewards",
        icon: UserRewardsIcon,
        showKey: "rewards",
      },
      {
        id: "settings-nav",
        label: "Settings",
        route: "/settings",
        icon: UserSettingsIcon,
        showKey: null, // always show
      },
      {
        id: "node-nav",
        label: "Node",
        route: "/node",
        icon: UserSettingsIcon,
        showKey: null,
        env: ["development", "staging"], // only show in non-prod
      },
    ].filter((nav) => {
      if (nav.showKey && !companyBrandingDetails?.[nav.showKey] && role !== "ADMIN") return false;
      if (nav.env && !nav.env.includes(process.env.ENVIRONMENT)) return false;
      return true;
    });
  };
  

  renderCommonNavigation = (CurrentLocation, getColor, hideContent, sideBarIconColor) => {
    const { hoverState } = this.state;
    const getRGBAColor = getColor ? hexToRGBA(getColor, 0.1) : null;
  
    return (
      <Navigation>
        {this.getCommonNavigationConfig().map((nav) => (
          <React.Fragment key={nav.id}>
            <li id={nav.id}>
              <StyledLink
                commonDashboard
                onClick={() => this.changeRoute(nav.route)}
                onMouseEnter={() => this.showCard(nav.label.toLowerCase())}
                onMouseLeave={() => this.hideCard()}
                active={CurrentLocation.includes(nav.route.replace("/", "")) ? 1 : 0}
                bgColor={getRGBAColor}
                colour={getColor || "#0b4170"}
                hideContent={hideContent ? 1 : 0}
              >
                <span className="iconLinkContainer">
                  <div>{nav.icon(sideBarIconColor)}</div>
                  {!hideContent && <span>{this.props.t(nav.label)}</span>}
                </span>
                <div dashboard={1} active={CurrentLocation.includes(nav.route.replace("/", "")) ? 1 : 0} />
              </StyledLink>
            </li>
            {hideContent && hoverState === nav.label.toLowerCase() && (
              <SidebarCard commonDashboard colour={getColor || "#0D4270"}>
                <div className="arrow">...</div>
                <div className="name">{this.props.t(nav.label)}</div>
              </SidebarCard>
            )}
          </React.Fragment>
        ))}
      </Navigation>
    );
  };

  renderCompanyNavigation = (CurrentLocation, getColor, hideContent, colorInfo,sideBarIconColor) => (
    <Navigation>
      {this.state.companyNavigationArrayState?.filter((nav) => nav.show).map((navigator, index) => (
        (<li id={navigator.id} key={index}>
          <StyledLink commonDashboard onClick={() => this.changeRoute(navigator.route)} onMouseEnter={() => this.showCardAdmin(navigator.value)} onMouseLeave={() => this.hideCardAdmin()}
            active={CurrentLocation.includes(navigator.active) ? 1 : 0}
            bgColor={getColor ? hexToRGBA(getColor, 0.1) : ''}
            colour={getColor ? getColor : "#0b4170"} hideContent={hideContent ? 1 : 0}
            width={"0px"} bottom={"0px"} left={"100px"} color={getColor ? getColor : "#0D4270"}
          >
            <span className="iconLinkContainer">
              <div>{navigator?.svg(sideBarIconColor)}</div>
              {hideContent ? null : <span>{navigator.name}</span>}
            </span>
            {hideContent && (this.state.hoverStateAdmin === navigator.value) ? <SidebarCard  width="0px" bottom="0px" left="100px" commonDashboard colour={getColor ? getColor : "#0D4270"}><div className="arrow">...</div><div className="name">{this.props.t(navigator.name)}</div></SidebarCard> : null}
            <div dashboard={1} />
          </StyledLink>
        </li>
        )
      ))}
    </Navigation>
  );

  renderNavigation = (currentLocation, getColor, hideContent, colorInfo,sideBarIconColor) => (
    <div>
      {
        currentLocation.includes('company') ? this.renderCompanyNavigation(currentLocation, getColor, hideContent, colorInfo,sideBarIconColor) :
          this.renderCommonNavigation(currentLocation, getColor, hideContent,sideBarIconColor)
      }
    </div>
  );

  

  render() {
    const { response, networkError, pathValue, reward, hideContent,history } = this.props;
    const { showSideBarMenu,brandingColor,companyBrandingDetails } = this.state;
    if ((!response || !reward) && !networkError) {
      return <Loading />
    }
    if (isUndefined(companyBrandingDetails) || isNull(companyBrandingDetails)) {
      return <Waiting />
    }
    
    const CurrentLocation = pathValue;
    const Visibility = hideContent;
    // const trainingCompleted = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

    let sideBarIconColor = applyOpacityToColor(brandingColor || 'rgb(11, 65, 112)', 0.5);
    const { pathname } = history.location;
    const firstSegment = pathname.split('/')[1]; // gets 'health-coach'
    const hideSidebar = firstSegment === 'health-coach';
    return (
      <SidebarGrid color={brandingColor || 'rgb(11, 65, 112)'} hideContent={hideContent ? 1 : 0} style={{display:hideSidebar && 'none'}}>
        <HamBurgerContainer onClick={this.showSideBarMenuOptions} showCompany={CurrentLocation.includes('company')}>
          <i className="fa fa-bars" />
        </HamBurgerContainer>
        <MainSideBarLinks smallDevices>
          {showSideBarMenu && this.renderNavigation(CurrentLocation, brandingColor, Visibility, companyBrandingDetails,sideBarIconColor)}
        </MainSideBarLinks>
        <MainSideBarLinks>
          {this.renderNavigation(CurrentLocation, brandingColor, Visibility, companyBrandingDetails,sideBarIconColor)}
        </MainSideBarLinks>
      </SidebarGrid>
    );
  }
}

SideBarV5.propTypes = {
  history: PropTypes.object.isRequired,
  response: PropTypes.object,
  networkError: PropTypes.string,
  pathValue: PropTypes.string.isRequired,
  reward: PropTypes.object,
  showReportTab: PropTypes.bool,
  role: PropTypes.string,
  userPermissions: PropTypes.array,
  colorData: PropTypes.object,
  hideContent: PropTypes.bool,
  hideTab: PropTypes.object,
  colorInformation: PropTypes.object,
  currentCompanyId: PropTypes.number,
  t: PropTypes.func,
  billingTabStatus: PropTypes.number,
  userCompany: PropTypes.object,
  setBrandingDetailsGlobally:PropTypes.func
};

const mapStateToProps = (state) => ({
  reward: state.wellnessDashboard.reward,
  showReportTab: state.companyDashboard.showReportTab,
  billingTabStatus: state.stripeData.billingTabStatus,
  hideTab: state.wellnessDashboard.companyBrandingDetails,
  userCompany: state.profileData.userCompany,
 
});

const mapDispatchToProps = (dispatch) => ({
  setBrandingDetailsGlobally:(res,bradningColor) => dispatch(setBrandingDetailsGlobally(res,bradningColor)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(SideBarV5));
